var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$route.params.mode === 'all' || _vm.$route.params.mode === 'user')?_c('scrum'):_vm._e(),(_vm.$route.params.mode === 'recurring')?_c('recurringTicketsTable'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }